import BulletedListIcon from '@carbon/icons/es/list--bulleted/16';
import NumberedListIcon from '@carbon/icons/es/list--numbered/16';
import ListEditing from '@ckeditor/ckeditor5-list/src/list/listediting';
import { createCarbonIconPlugin } from './carbon-icon';

export const BULLETED_LIST = 'bulletedList';
export const NUMBERED_LIST = 'numberedList';
export const List = createCarbonIconPlugin({
  editing: ListEditing,
  name: 'BulletedList',
  uis: [
    {
      command: BULLETED_LIST,
      icon: BulletedListIcon,
      label: 'Bulleted Section',
    },
    {
      command: NUMBERED_LIST,
      icon: NumberedListIcon,
      label: 'Numbered Section',
    },
  ],
});
